export default {"src":"/_next/static/media/icon-logout.c2c5a480.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};